import React from "react";
import Modal from "../utils/Modal/Modal";
import { ReactComponent as CloseIcon } from "../../assets/icons/close.svg";

import {
  ModalContainer,
  ModalMessage,
  PromptCloseButton,
  PromptModalButtons,
  PromptModalHeader,
  PromptModalTitle,
  PromptSubmitButton,
} from "./UnlockModal.styles";
import { useNavigate } from "react-router-dom";

const UnlockModal = ({ isOpen, onClose }) => {
  const navigate = useNavigate();
  return (
    <Modal isOpen={isOpen} onClose={onClose}>
      <ModalContainer>
        <PromptModalHeader>
          <PromptModalTitle>Unlock more Features</PromptModalTitle>
          <PromptCloseButton
            onClick={() => {
              onClose();
            }}
          >
            <CloseIcon />
          </PromptCloseButton>
        </PromptModalHeader>
        <ModalMessage>Ready to take videos to the next level? </ModalMessage>

        <PromptModalButtons>
          <PromptSubmitButton
            onClick={() => {
              navigate("/subscription");
              onClose();

              window.scrollTo({
                top: 0,
                left: 0,
                behavior: "instant",
              });
            }}
          >
            Explore Subscription Plans
          </PromptSubmitButton>
        </PromptModalButtons>
      </ModalContainer>
    </Modal>
  );
};

export default UnlockModal;
